import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  // Naturaleza jurídica: PUBLIC | PRIVATE | MIXED | NONPROFIT | INTERNATIONAL,
  // o null para no filtrar.
  entityType: null,
  // ACTIVE | INACTIVE, o null.
  status: null,
};

export const entitySlice = createSlice({
  name: "entity",
  initialState: {
    list: [],
    loading: false,
    filters: initialFilters,
    current: null,
  },
  reducers: {
    setEntityLoading: (state, action) => {
      state.loading = !!action.payload;
    },
    setEntityList: (state, action) => {
      state.list = action.payload || [];
      state.loading = false;
    },
    // Paginación con cursor: agrega la siguiente página, de-duplicando por nit
    // (el id del documento).
    appendEntityList: (state, action) => {
      const incoming = action.payload || [];
      if (!incoming.length) return;
      const seen = new Set(state.list.map((e) => e.nit));
      for (const item of incoming) {
        if (!seen.has(item.nit)) {
          state.list.push(item);
          seen.add(item.nit);
        }
      }
    },
    // Tras crear o editar: reemplaza la entidad en la lista sin recargar la
    // página entera, o la pone de primera si es nueva.
    upsertEntity: (state, action) => {
      const item = action.payload;
      if (!item || !item.nit) return;
      const index = state.list.findIndex((e) => e.nit === item.nit);
      if (index >= 0) state.list[index] = { ...state.list[index], ...item };
      else state.list.unshift(item);
      if (state.current && state.current.nit === item.nit) {
        state.current = { ...state.current, ...item };
      }
    },
    removeEntity: (state, action) => {
      const nit = action.payload;
      state.list = state.list.filter((e) => e.nit !== nit);
      if (state.current && state.current.nit === nit) state.current = null;
    },
    setEntityFilters: (state, action) => {
      state.filters = { ...state.filters, ...(action.payload || {}) };
    },
    resetEntityFilters: (state) => {
      state.filters = initialFilters;
    },
    setCurrentEntity: (state, action) => {
      state.current = action.payload || null;
    },
  },
});

export const {
  setEntityLoading,
  setEntityList,
  appendEntityList,
  upsertEntity,
  removeEntity,
  setEntityFilters,
  resetEntityFilters,
  setCurrentEntity,
} = entitySlice.actions;

export default entitySlice.reducer;
